import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import CabecalhoAdmin from "../../../componentes/CabecalhoAdmin";
import MenuLateral from "../../../componentes/MenuLateral";
import Botao from "../../../componentes/Botao";
import Pesquisa from "../../../componentes/Pesquisa";
import ModalPergunta from "../../../componentes/ModalPergunta";
import ErroSpan from "../../../componentes/ErroSpan";
import { AreaSuperior, FiltrarData, InputMes, LinksPaginas, OpcoesFiltragem, PaginasTabela, RodapePaginas, SecaoAdmin, SecaoPrincipal, TotalDocs } from "../AdminStyled";
import { buscaSelecionadas, deletarComissoes, editarComissoes, getComissoesManuais } from "../../../servicos/comissoesServices";
import { TabComissoesManuais } from "./TabComissoesManuais";
import { baixarArquivoSemSalvar } from "./arquivoBanco2";

export default function PagManual(){
    // Vetor de comissões
    const [comissoes, setComissoes] = useState([]);

    // Status para mostrar avisos ao usuário
    const [status, setStatus] = useState({
        erro: false,
        sucesso: false,
        mensagem: undefined
    });

    // Controle do total de documentos com os filtros selecionados e páginas
    const [total, setTotal] = useState({ paginas: 1, docs: 0 });

    // Variáveis para controlar página, ordem e ordenação dos documentos
    const [pagina, setPagina] = useState(1);
    const [ordem, setOrdem] = useState(1);
    const [ordenacao, setOrdenacao] = useState("dataPagamento");

    // Variável para pesquisar documentos pelo nome do guia
    const [nomeGuia, setNomeGuia] = useState("");
    
    // Controle dos filtros aplicados na página
    const [filtros, setFiltros] = useState({
        dataPagamento: null,
        pagamentoEfetivado: null
    });

    // Controle do valor total de comissão
    const [totais, setTotais] = useState(null);

    // Controle dos documentos selecionados e seus valores totais
    const [selecionados, setSelecionados] = useState([]);
    const [totalSelecionado, setTotalSelecionado] = useState(0);

    // Controle de visibilidade de modais de pergunta de ação
    const [showAvisoDelete, setShowAvisoDelete] = useState(false);
    const [showAvisoGerarDoc, setShowAvisoGerarDoc] = useState(false);
    const [showAvisoPago, setShowAvisoPago] = useState(false);

    // Variável indicando a quantidade de documentos da página que estão selecionados
    const [selecionadosPagina, setSelecionadosPagina] = useState(0);

    // Atualização dos documentos com base nas alterações de variáveis de estado
    useEffect( () => {
        obterComissoes(nomeGuia, filtros, pagina, ordem, ordenacao);
    }, [nomeGuia, filtros, pagina, ordem, ordenacao]);

    useEffect( () => {
        atualizaSelecionadosPagina(comissoes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comissoes]);

    // Função que busca os documentos no banco e atualiza comissões e totais
    async function obterComissoes(nomeGuia, filtros, paginaAtual, ordemAtual, ordenacaoAtual) {
        setStatus({
            erro: true,
            sucesso: false,
            mensagem: "Carregando..."
        });

        // nomeGuia, filtros, pagina = 1, ordenacao = "dataPagamento", ordem = 1, limite = 30, pago
        filtros = {...filtros, pagamentoEfetivado: JSON.parse(filtros.pagamentoEfetivado)};
        if (filtros.pagamentoEfetivado) filtros = {...filtros, pagamentoEfetivado: filtros.pagamentoEfetivado.value};
        getComissoesManuais(nomeGuia, filtros, paginaAtual, ordenacaoAtual, ordemAtual).then( resposta => {
            setComissoes(resposta.dados);
            setTotal({
                paginas: Math.ceil(resposta.totalDocs/30),
                docs: resposta.totalDocs
            });
            if (resposta.dados && resposta.dados.length > 0) {
                setTotais({
                    totalTour: resposta.dados.reduce( (total, atual) => total + atual.comissaoTour, 0).toFixed(2),
                    totalLojaTour: resposta.dados.reduce( (total, atual) => total + atual.comissaoLojaTour, 0).toFixed(2),
                    totalLojaCentro: resposta.dados.reduce( (total, atual) => total + atual.comissaoLojaCentro, 0).toFixed(2),
                    totalTotal: resposta.dados.reduce( (total, atual) => total + atual.comissaoTotal, 0).toFixed(2)
                });
            }
            setStatus({
                erro: false,
                sucesso: false,
                mensagem: ""
            });
        });
    }

    async function gerarArquivoBanco() {
        setStatus({
            erro: true,
            sucesso: false,
            mensagem: "Carregando..."
        });

        // Busca as comissões selecionadas ("selecionadas" armazena apenas o identificador)
        const comissoesParaRemessa = await buscaSelecionadas(selecionados);
        baixarArquivoSemSalvar(comissoesParaRemessa, totalSelecionado, setStatus);
    }

    async function marcarComoPago() {
        setStatus({
            erro: true,
            sucesso: false,
            mensagem: "Carregando..."
        });

        // Cria vetor com filtro das comissões para atualizar
        const paraAtualizar = selecionados.map( com => ({ identificador: com }));

        // Valores para atualizar as comissões
        const atualizacao = {
            pagamentoEfetivado: true,
            mensagem: "Pagamento manual",
            ocorrencias: ["Marcado como pago manualmente"]
        };

        // Envia para a atualização no banco de dados
        const resposta = await editarComissoes(paraAtualizar, atualizacao);

        
        // Verifica se a atualização deu certo
        if (resposta.status === 200) {
            await obterComissoes(nomeGuia, filtros, pagina, ordem, ordenacao);
            setTimeout( () => setStatus({ erro: false, sucesso: true, mensagem: resposta.mensagem }), 400); 
            setTimeout( () => setStatus({ erro: false, sucesso: false, mensagem: "" }), 3000); 
        } else setStatus({ erro: true, sucesso: false, mensagem: resposta.mensagem });
    }

    async function deletarSelecionados() {
        setStatus({
            erro: true,
            sucesso: false,
            mensagem: "Carregando..."
        });

        // Envia para o servidor deletar documentos cujo identificador esteja no vetor de selecionados
        const resposta = await deletarComissoes({ identificador: { $in: selecionados }});

        if (resposta.status === 200) {
            obterComissoes(nomeGuia, filtros, pagina, ordem, ordenacao);
        } else {
            setStatus({ erro: true, sucesso: false, mensagem: resposta.mensagem });
        }
    }

    function atualizaSelecionadosPagina(verifica) {
        // Contagem de comissões selecionadas da página
        let aux = 0;

        if (comissoes && comissoes.length > 0) {
            verifica.forEach( com => {
                if (selecionados.includes(com.identificador)){
                    aux++;
                }
            });
        }

        setSelecionadosPagina(aux);
    }

    const handleSimDelete =  () => {
        deletarSelecionados();
        setSelecionados([]);
        setShowAvisoDelete(false);
        setTotalSelecionado(0);
    };
    const handleSimGerarDoc = () => {
        gerarArquivoBanco();
        setShowAvisoGerarDoc(false);
    };
    const handleSimPago = () => {
        marcarComoPago();
        setShowAvisoPago(false);
    };
    const handleNao = async () => {
        setShowAvisoDelete(false);
        setShowAvisoGerarDoc(false);
        setShowAvisoPago(false);
    };

    const opcoesEfetivado = [
        { value: "true", label: "Sim" },
        { value: "false", label: "Não" }
    ]

    return (<SecaoAdmin>
        <MenuLateral />
        <SecaoPrincipal>
            {ModalPergunta(`Tem certeza que deseja deletar estas ${selecionados.length} comissões?`, handleSimDelete, handleNao, showAvisoDelete, "100px")}
            {ModalPergunta(`Tem certeza que deseja gerar uma remessa de ${selecionados.length} comissões?`, handleSimGerarDoc, handleNao, showAvisoGerarDoc, "100px")}
            {ModalPergunta(`Tem certeza que deseja marcar estas ${selecionados.length} comissões como pagas?`, handleSimPago, handleNao, showAvisoPago, "100px")}
            {CabecalhoAdmin("Cadastro manual de comissões")}
            {status.erro && <ErroSpan>{status.mensagem}</ErroSpan>}
            {status.sucesso && <ErroSpan $corFundo={"#ddffcd"} $corTexto={"#209e00"} >{status.mensagem}</ErroSpan>}
            <AreaSuperior>
                <RodapePaginas>
                    <FiltrarData $marginTop="1px">
                        <label>Data pagamento</label>
                        <InputMes type="date" defaultValue={null} onChange={event => setFiltros({...filtros, dataPagamento: event.target.value})}/>
                    </FiltrarData>
                    <FiltrarData>
                        <label>Efetivado</label>
                        <Select 
                            options={opcoesEfetivado} 
                            isClearable={true}
                            placeholder="Filtrar pagos"
                            value={JSON.parse(filtros.pagamentoEfetivado)}
                            onChange={e => setFiltros({...filtros, pagamentoEfetivado: JSON.stringify(e)})}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderRadius: "2px",
                                    border: "1px solid #252525",
                                    width: "200px",
                                    height: "31px",
                                    minHeight: '30px',
                                    fontSize: "14px",
                                    borderColor: state.hover ? 'black' : 'rgba(58, 23, 14, 0.308)' 
                                }),
                                input: (provided, state) => ({
                                    ...provided,
                                    margin: '0px',
                                    }),
                                valueContainer: (provided, state) => ({
                                    ...provided,
                                    height: '30px',
                                    padding: '0 6px'
                                }),
                                indicatorsContainer: (provided, state) => ({
                                    ...provided,
                                    height: '30px',
                                }),
                                option: (baseStyles) => ({
                                    ...baseStyles,
                                    color: "black"
                                })
                            }}
                        />
                    </FiltrarData>
                </RodapePaginas>
                {Pesquisa(setNomeGuia, setPagina, nomeGuia)}
            </AreaSuperior>
            <AreaSuperior>
                <p>Comissões selecionadas: {selecionados.length}</p>
                <OpcoesFiltragem>
                    <Link to="/admin/comissoes/manual/cadastrar"><Botao $marginRight="10px">Nova comissão</Botao></Link>
                    <Botao $marginRight="10px" onClick={() => selecionados.length > 0? setShowAvisoPago(true): ""}>Pago</Botao>
                    <Botao $marginRight="10px" onClick={() => selecionados.length > 0? setShowAvisoGerarDoc(true): ""}>Gerar arquivo</Botao>
                    <Botao $marginRight="20px" $cor="#ff2424" onClick={() => selecionados.length > 0? setShowAvisoDelete(true): ""}>Excluir</Botao>
                </OpcoesFiltragem>
            </AreaSuperior>
            {comissoes && <>{TabComissoesManuais(comissoes, totais, ordenacao, ordem, setOrdenacao, setOrdem, selecionados, setSelecionados, selecionadosPagina, setSelecionadosPagina, totalSelecionado, setTotalSelecionado)}
            <RodapePaginas>
                <TotalDocs>
                    <p>Total de documentos: {total.docs}</p>
                </TotalDocs>
                <PaginasTabela>
                    <p onClick={() => setPagina(1)}>Primeira</p>
                    <p onClick={() => {
                        if (pagina > 1) setPagina(pagina-1);
                        }
                    }>Anterior</p>
                    {paginas()}
                    <p onClick={() => {
                        if (pagina < total.paginas) setPagina(pagina+1);
                    }}>Próxima</p>
                    <p onClick={() => setPagina(total.paginas)}>Última</p>
                </PaginasTabela>
            </RodapePaginas>
            </>
            }
        </SecaoPrincipal>
    </SecaoAdmin>)

    function paginas() {
        let pages = [];
        let ajuste = 2;
    
        if (pagina === 1){
            ajuste = 0;
        } else if (pagina === 2){
            ajuste = 1;
        } else if (pagina === total.paginas-1 && total.paginas > 4){
            ajuste = 3;
        } else if (pagina === total.paginas && total.paginas > 4){
            ajuste = 4;
        }
        if (total.paginas < 5){
            for (let i = 0; i < total.paginas; i++){
                let pageNum = parseInt(i+1);
    
                if (pageNum === pagina) {
                    pages.push(<LinksPaginas key = {`page${pageNum}`} $corFundo="var(--corNugaliEscura)" $cor="white">{pageNum}</LinksPaginas>)
                }else {
                    pages.push(<LinksPaginas 
                        key = {`page${pageNum}`}
                        id={pageNum} 
                        onClick={event => setPagina(parseInt(event.currentTarget.id))
                        }>
                        {pageNum}
                    </LinksPaginas>)
                }
            }
        } else {
            for (let i = 0; i < 5; i++){
                let pageNum = parseInt(pagina) + parseInt(i) - ajuste;
                if (pageNum === pagina) {
                    pages.push(<LinksPaginas key = {`page${pageNum}`} $corFundo="var(--corNugaliEscura)" $cor="white">{pageNum}</LinksPaginas>)
                }else {
                    pages.push(<LinksPaginas 
                        key = {`page${pageNum}`}
                        id={pageNum} 
                        onClick={event => setPagina(parseInt(event.currentTarget.id))
                        }>
                        {pageNum}
                    </LinksPaginas>)
                }
            }
        }    
        return pages;
    }
}
